import ImageSlot from '../ImageSlot';

// Image-led transition from the warm editorial passage into Midnight.
export default function TransitionBand() {
  return (
    <div data-header-theme="midnight" data-testid="transition-band" className="relative bg-midnight">
      <div className="relative h-[30vh] max-h-[360px] min-h-[210px] overflow-hidden">
        <ImageSlot slotKey="arch" fill className="absolute inset-0" />
        <div className="absolute inset-0 bg-midnight/45" aria-hidden="true" />
      </div>
    </div>
  );
}
